<div class="top-header">
  <div class="top-header-left">
    <p>{{ headerData.headerReportLabelKey|translate:headerData.language:ModuleNames.Shared}}</p>
  </div>
  <div class="top-header-right">
    <p>{{ headerData.rightLabelKey|translate:headerData.language:ModuleNames.Shared }} &nbsp; <span> {{
        headerData.surveyName }}</span></p>
  </div>
</div>